export const vermont = {
  "50000": "Vermont",
  "50001": "Addison County",
  "50003": "Bennington County",
  "50005": "Caledonia County",
  "50007": "Chittenden County",
  "50009": "Essex County",
  "50011": "Franklin County",
  "50013": "Grand Isle County",
  "50015": "Lamoille County",
  "50017": "Orange County",
  "50019": "Orleans County",
  "50021": "Rutland County",
  "50023": "Washington County",
  "50025": "Windham County",
  "50027": "Windsor County",
};
